// extracted by mini-css-extract-plugin
module.exports = {"address":"styles_address__3M6ha","active":"styles_active__32Ou7","phones":"styles_phones__2rWN2"};